import React from 'react';
import PropTypes from 'prop-types';
import { ProgressBar } from 'react-bootstrap';

const progressBarFormatter = ({ value }) => {
  return <div style={{ paddingBottom: '3px' }}><ProgressBar now={`${parseFloat(value).toFixed(2)}`} label={`${parseFloat(value).toFixed(2)}%`} /></div>;
};

progressBarFormatter.propTypes = ({
  value: PropTypes.number.isRequired
});

export default progressBarFormatter;
